const userManage = {
    state: {

    },
    mutations: {

    }

}
export default userManage